// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mk8puBw76sNXG_ {
  display: flex;
  flex-flow: row;
  flex-wrap: wrap;
}
.S94ErKICoJLWuB {
  display: flex;
  justify-content: center;
}
.uhJMPwDhspGoHX {
  flex: 1 1 auto;
  min-height: calc(100vh - 80px);
  padding-bottom: 32px;
  background-color: var(--ds-background-accent-gray-subtlest, #f1f2f4);
}
.EiQ0cIkoaS_6OD {
  display: flex;
  justify-content: center;
  padding: 32px;
}
.OTaY1ctkDzSpAR {
  font-style: italic;
}
.iickVjVp0u0Ob2 {
  flex-grow: 1;
  min-width: 320px;
  max-width: 800px;
  padding: 32px;
  border: 1px solid var(--ds-border, #091e4224);
  border-radius: 4px;
  background-color: var(--ds-surface, #ffffff);
}
.udfwxg4kvzGUE_ {
  display: flex;
  align-items: center;
  justify-content: center;
}
.GUst_b4sKz29LT {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--ds-border, #091e4224);
}
.GUst_b4sKz29LT .pli621nOR1Oc9d {
  margin: 12px 0 0;
}
.fr3xcOxJTFZLtk {
  padding-top: 16px;
  border-top: 1px solid var(--ds-border, #091e4224);
}
.fr3xcOxJTFZLtk button {
  margin-left: 8px;
}
.TqnoXQyDN5ko2M {
  display: flex;
  justify-content: flex-end;
}
@media only screen and (max-width: 900px) {
  .iickVjVp0u0Ob2 {
    padding: 16px;
  }
}
.eRsjkDooXexF3M {
  width: 480px;
}
.b8Sp4L8FI1BXs5 {
  min-width: 100%;
}
.jnQSfeWt2L7YD5 {
  margin-bottom: 16px;
}
.jnQSfeWt2L7YD5 label {
  font-weight: 700;
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  display: block;
  margin-top: 12px;
  margin-bottom: 4px;
}
.jnQSfeWt2L7YD5 input[type='text'],
.jnQSfeWt2L7YD5 input[type='email'] {
  color: var(--ds-text, #172b4d);
  font-family: var(--ds-font-family-body, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  font-display: swap;
  padding: 8px 12px;
  border-radius: 3px;
  transition-property: background-color, border-color, box-shadow;
  transition-duration: 85ms;
  transition-timing-function: ease;
  box-sizing: border-box;
  border: none;
  outline: none;
  background-color: var(--ds-background-input, #ffffff);
  box-shadow: inset 0 0 0 1px var(--ds-border-input, #091e4224);
  display: block;
  width: 100%;
  margin-top: 4px;
  margin-bottom: 12px;
}
.jnQSfeWt2L7YD5 input[type='text']:hover,
.jnQSfeWt2L7YD5 input[type='email']:hover {
  background-color: var(--ds-background-input-hovered, #f7f8f9);
  box-shadow: inset 0 0 0 1px var(--ds-border-input, #091e4224);
}
.jnQSfeWt2L7YD5 input[type='text']:focus,
.jnQSfeWt2L7YD5 input[type='email']:focus {
  background-color: var(--ds-background-input, #ffffff);
  box-shadow: inset 0 0 0 2px var(--ds-border-focused, #388bff);
}
.jnQSfeWt2L7YD5 input[type='text']:disabled,
.jnQSfeWt2L7YD5 input[type='email']:disabled {
  background-color: var(--ds-background-disabled, #091e4208);
  box-shadow: none;
  color: var(--ds-text-disabled, #091e424f);
  cursor: not-allowed;
  -webkit-user-select: none;
          user-select: none;
}
.jnQSfeWt2L7YD5 input[type='text'][readonly],
.jnQSfeWt2L7YD5 input[type='email'][readonly] {
  background-color: var(--ds-background-disabled, #091e4208);
  box-shadow: inset 0 0 0 2px var(--ds-border-input, #091e4224);
}
.jnQSfeWt2L7YD5 input[type='text'].qfAsk42mikz8_D,
.jnQSfeWt2L7YD5 input[type='email'].qfAsk42mikz8_D {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
.jnQSfeWt2L7YD5 input[type='text'].qfAsk42mikz8_D:hover,
.jnQSfeWt2L7YD5 input[type='email'].qfAsk42mikz8_D:hover {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
.jnQSfeWt2L7YD5 input[type='text'].qfAsk42mikz8_D:focus,
.jnQSfeWt2L7YD5 input[type='email'].qfAsk42mikz8_D:focus {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
.jnQSfeWt2L7YD5 input[type='text'].PKfhgGzkCQQBI7,
.jnQSfeWt2L7YD5 input[type='email'].PKfhgGzkCQQBI7 {
  width: 100%;
}
.jnQSfeWt2L7YD5 input[type='text']::placeholder,
.jnQSfeWt2L7YD5 input[type='email']::placeholder {
  color: var(--ds-text-subtlest, #626f86);
}
.Y_8UoFteAnu0K2 {
  margin-top: 16px;
}
.fr3xcOxJTFZLtk a {
  text-decoration: none;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flexRowWrap": `mk8puBw76sNXG_`,
	"flexAndCenter": `S94ErKICoJLWuB`,
	"body": `uhJMPwDhspGoHX`,
	"navigationAndContent": `EiQ0cIkoaS_6OD`,
	"learnMoreSubtle": `OTaY1ctkDzSpAR`,
	"content": `iickVjVp0u0Ob2`,
	"spinnerContainer": `udfwxg4kvzGUE_`,
	"header": `GUst_b4sKz29LT`,
	"title": `pli621nOR1Oc9d`,
	"footer": `fr3xcOxJTFZLtk`,
	"formFooter": `TqnoXQyDN5ko2M`,
	"createPowerUpContainer": `eRsjkDooXexF3M`,
	"pluginInput": `b8Sp4L8FI1BXs5`,
	"createFormSection": `jnQSfeWt2L7YD5`,
	"input-error": `qfAsk42mikz8_D`,
	"full": `PKfhgGzkCQQBI7`,
	"teamDescription": `Y_8UoFteAnu0K2`
};
export default ___CSS_LOADER_EXPORT___;
